import React from 'react';

const ScrollPositionContext = React.createContext();

export default ScrollPositionContext;
